module.exports = __webpack_public_path__ + "static/media/Datadog_Logo.11424e9b.png";